<template>
  <div :class="`grid-layout__item gl-w-${widget.w} gl-x-${widget.x} ${isCard ? 'u-padding-4-px' : ''}`" >
    <div class="grid-layout__item--content"></div>
  </div>
</template>
<script>
export default {
  props: {
    widget: {
      type: Object,
      default: () => ({}),
    },
    isCard: {
      type: Boolean,
      default: false,
    },
  },
};
</script >
<style lang="scss" scoped>
.grid-layout__item {
  border: none;
  padding: 2px;
}

.u-padding-4-px {
  padding: 4px;
  .grid-layout__item--content {
    border-radius: 5px;
  }
}
</style>
